<template>
  <div>
    <div>門牌圖片：{{ commemorativeDoorplateImageDisplayLabel }}</div>
    <div v-if="engravingContent.commemorativeDoorplateImageOption === 'custom'">
      圖片描述：{{ engravingContent.commemorativeDoorplateImageCustom }}
    </div>

    <div>縣市區域：{{ engravingContent.commemorativeDoorplateDistrict }}</div>
    <div>路名：{{ engravingContent.commemorativeDoorplateRoadName }}</div>
    <div>門牌號：{{ engravingContent.commemorativeDoorplateHouseNumber }}</div>
    <div>
      反面文字：{{ engravingContent.commemorativeDoorplateReverseText }}
    </div>
  </div>
</template>
<script>
import { commemorativeDoorplateImageOptions } from "@/constData/engravingData";
export default {
  name: "DisplayCommemorativeDoorplate",
  props: {
    engravingContent: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      commemorativeDoorplateImageOptions: commemorativeDoorplateImageOptions,
    };
  },
  computed: {
    commemorativeDoorplateImageDisplayLabel() {
      const option = commemorativeDoorplateImageOptions.find(
        (option) =>
          option.value ===
          this.engravingContent.commemorativeDoorplateImageOption
      );
      return option ? option.label : "";
    },
  },
};
</script>
<style scoped lang="scss">
div {
  margin: 6px 0;
}
</style>
